/*
 * Copyright (c) 2024 Pegasystems Inc.
 * All rights reserved.
 */
import AnnotationsHandler from '..';
import Constants from '../../constants';
import { C11nEnv } from '../../interpreter/c11n-env';
import { getContextValue } from '../../store/state/state-manager';
import type { NodeProps } from '../../contextree/types';

AnnotationsHandler.registerHandler('@W', (value: string, c11nEnv: C11nEnv, contextTreeNodeProps?: NodeProps) => {
  let whenResult;
  if (c11nEnv) {
    whenResult = c11nEnv.getContextDataValue(`.${Constants.SUMMARY_OF_WHEN_CONDITIONS}.${value}`) as string | boolean;
  } else {
    const { pageReference, context } = contextTreeNodeProps ?? {};
    whenResult = getContextValue(pageReference, `.${Constants.SUMMARY_OF_WHEN_CONDITIONS}.${value}`, context);
  }
  return whenResult === true || whenResult === 'true';
});
